"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Rule = void 0;
const join_condition_1 = require("./join-condition");
const with_class_name_1 = require("../with-class-name");
class Rule extends with_class_name_1.WithClassName {
    constructor() {
        super(...arguments);
        this.joinCondition = new join_condition_1.JoinCondition();
    }
    add(conditionType) {
        this.joinCondition.add(conditionType);
    }
}
exports.Rule = Rule;



//////////////////
// WEBPACK FOOTER
// ./~/rules-config/lib/casa-rules-v2/rule.js
// module id = 1245
// module chunks = 0